import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import generalClasses from './Settings.module.css'
import { Button } from '../../../components/Button/Button'
import classes from '../../Account/Subscription/subscription.module.css'
import visaIcon from '../../../assets/icons/visa.png'
import moment from 'moment'
import { convertToFormatted } from '../../../util/functions'
import Modal from '../../../components/Modal/Modal'
import Checkbox from '../../../components/Form/Checkbox/Checkbox'
import { useDispatch, useSelector } from 'react-redux'
import { userSelectors } from '../../../redux/userSlice'
import {
    getCurrentSub,
    getSubHistory,
} from '../../Account/Subscription/subscriptionApi'
import { subscriptionSelectors } from '../../Account/Subscription/subscriptionSlice'
import notification from '../../../components/Notification/notification'
import {
    NextPaymentLoader,
    PaymentHistoryLoader,
    ProfileSubscriptionTitleLoader,
} from '../../../components/loaders/ProfileSubscriptionLoader'
import CancelModal from '../../../components/CancelModal/CancelModal'
import { startWizard } from '../../Wizard/wizardLogic'
import { useHistory } from 'react-router'
import { AccountTypes } from '../../../util/constants'

const cancelReasons = [
    'Lorem ipsum dolor sit amet',
    'Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut',
    'Labore et dolore magna aliqua. Ut enim ad minim veniam',
    'Quis nostrud exercitation ullamco laboris nisi ut aliquip ex',
    'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore',
    'Excepteur sint occaecat cupidatat non proident',
]

const cancellationCheckboxes = cancelReasons.map(reason => ({
    reason,
    checked: false,
}))

const PaymentHistoryRow = ({ description, date, paymentMethod, amount }) => (
    <div className={classes.paymentHistoryRow}>
        <span className={classes.paymentHistoryRowItem}>
            <span className={classes.paymentHistoryRowItemLabel}>
                Description: {'  '}
            </span>
            {description}
        </span>
        <span className={classes.paymentHistoryRowItem}>
            <span className={classes.paymentHistoryRowItemLabel}>
                Date: {'  '}
            </span>
            {moment(date).format('DD/MM/YYYY')}
        </span>
        <span
            className={classNames(
                classes.paymentHistoryRowItem,
                classes.paymentHistoryRowItemBold
            )}
        >
            <span className={classes.paymentHistoryRowItemLabel}>
                Amount: {'  '}
            </span>
            {convertToFormatted(amount, true)}
        </span>
    </div>
)

const BusinessSettingsBilling = () => {
    const handleSubmit = event => {
        event.preventDefault()
    }

    const history = useHistory()

    const onUpgrade = () => {
        history.push(startWizard({ isUpgrade: true }))
    }

    const [modalOpen, setModalOpen] = useState(false)

    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    useEffect(() => {
        dispatch(getCurrentSub(user.email))
        dispatch(getSubHistory(user.email))
    }, [])

    const isFetchingCurrentSub = useSelector(
        subscriptionSelectors.isFetchingCurrentSub
    )
    const currentSubHasError = useSelector(
        subscriptionSelectors.currentSubHasError
    )
    const currentSubErrorMessage = useSelector(
        subscriptionSelectors.currentSubErrorMessage
    )
    const currentSub = useSelector(subscriptionSelectors.currentSub)

    useEffect(() => {
        if (!isFetchingCurrentSub && currentSubHasError) {
            notification.failure({
                title: 'Something went wrong with fetching your active plan',
                description: currentSubErrorMessage,
            })
        }
    }, [isFetchingCurrentSub])

    const isFetchingSubHistory = useSelector(
        subscriptionSelectors.isFetchingSubHistory
    )
    const subHistoryHasError = useSelector(
        subscriptionSelectors.subHistoryHasError
    )
    const subHistoryErrorMessage = useSelector(
        subscriptionSelectors.subHistoryErrorMessage
    )
    const subHistory = useSelector(subscriptionSelectors.subHistory)

    useEffect(() => {
        if (!isFetchingSubHistory && subHistoryHasError) {
            notification.failure({
                title:
                    'Something went wrong with fetching subscription history',
                description: subHistoryErrorMessage,
            })
        }
    }, [isFetchingSubHistory])

    const subscribedUser =
        user.accounttype?.toLowerCase() ===
        AccountTypes.Subscriber?.toLowerCase()

    return (
        <form onSubmit={handleSubmit}>
            <div className={generalClasses.formSection}>
                <div className={generalClasses.formSectionDescription}>
                    <h6 className={generalClasses.formSectionTitle}>Billing</h6>
                    <p className={generalClasses.formSectionSubtitle}>
                        See your billing history here
                    </p>
                </div>
                <div className={generalClasses.formSectionInputs}>
                    <div className={classes.currentSubscription}>
                        {isFetchingCurrentSub ? (
                            <ProfileSubscriptionTitleLoader />
                        ) : (
                            <div className={classes.currentSubscriptionText}>
                                {user.accounttype ? (
                                    <>
                                        <h3
                                            className={
                                                classes.currentSubscriptionTextHeader
                                            }
                                        >
                                            {currentSub.subscription.title}
                                        </h3>
                                        <p
                                            className={
                                                classes.currentSubscriptionTextSubtext
                                            }
                                        >
                                            You are a/an{' '}
                                            {currentSub.subscription.title} user
                                            since,{' '}
                                            {moment(currentSub.subdate).format(
                                                'DD/MM/YYYY'
                                            )}
                                        </p>
                                    </>
                                ) : (
                                    <h3
                                        className={
                                            classes.currentSubscriptionTextHeader
                                        }
                                    >
                                        Upturn Free
                                    </h3>
                                )}
                            </div>
                        )}
                        <Button
                            className={classes.currentSubscriptionButton}
                            onClick={onUpgrade}
                            bold
                        >
                            Upgrade Plan
                        </Button>
                    </div>
                    {user.accounttype && (
                        <>
                            <div className={classes.subscriptionGrid}>
                                <span
                                    className={
                                        classes.subscriptionSectionHeader
                                    }
                                >
                                    Next payment date
                                </span>
                                {isFetchingSubHistory ? (
                                    <NextPaymentLoader />
                                ) : (
                                    <div
                                        className={
                                            classes.nextPaymentDateDetails
                                        }
                                    >
                                        <span
                                            className={
                                                classes.nextPaymentDateDetailsText
                                            }
                                        >
                                            Amount:
                                            <span
                                                className={
                                                    classes.nextPaymentDateDetailsTextBold
                                                }
                                            >
                                                {'  '}
                                                {convertToFormatted(
                                                    currentSub.subscription
                                                        .amount,
                                                    true
                                                )}
                                            </span>
                                        </span>
                                        <span
                                            className={
                                                classes.nextPaymentDateDetailsText
                                            }
                                        >
                                            Date:
                                            <span
                                                className={
                                                    classes.nextPaymentDateDetailsTextBold
                                                }
                                            >
                                                {'  '}
                                                {moment(
                                                    currentSub.expdate
                                                ).format('DD/MM/YYYY')}
                                            </span>
                                        </span>
                                    </div>
                                )}
                            </div>
                            {subscribedUser && (
                                <>
                                    <span className={classes.splitLine} />
                                    <div className={classes.subscriptionCancel}>
                                        <span className={classes.cancelText}>
                                            Want to cancel your subscription?
                                        </span>
                                        <button
                                            className={classes.cancelButton}
                                            onClick={() => setModalOpen(true)}
                                        >
                                            Cancel Subscription
                                        </button>
                                    </div>
                                </>
                            )}
                            <span className={classes.splitLine} />
                            <div className={classes.paymentHistory}>
                                <h1
                                    className={classNames(
                                        classes.subscriptionSectionHeader,
                                        classes.paymentHistoryHeader
                                    )}
                                >
                                    Payment History
                                </h1>
                                <div
                                    className={classNames(
                                        classes.paymentHistoryRow,
                                        classes.paymentHistoryHeaderRow
                                    )}
                                >
                                    <span
                                        className={
                                            classes.paymentHistoryRowHeader
                                        }
                                    >
                                        DESCRIPTION
                                    </span>
                                    <span
                                        className={
                                            classes.paymentHistoryRowHeader
                                        }
                                    >
                                        DATE
                                    </span>
                                    <span
                                        className={
                                            classes.paymentHistoryRowHeader
                                        }
                                    >
                                        AMOUNT
                                    </span>
                                </div>
                                {isFetchingSubHistory ? (
                                    <PaymentHistoryLoader />
                                ) : (
                                    subHistory.map(
                                        ({ subscription, subdate, log }) => (
                                            <>
                                                <PaymentHistoryRow
                                                    date={subdate}
                                                    amount={log.cashamount}
                                                    description={
                                                        subscription.title
                                                    }
                                                />
                                            </>
                                        )
                                    )
                                )}
                                {!isFetchingSubHistory &&
                                    subHistory.length === 0 && (
                                        <h1
                                            className={
                                                classes.paymentHistoryEmpty
                                            }
                                        >
                                            No subscription history
                                        </h1>
                                    )}
                            </div>
                            <CancelModal
                                modalOpen={modalOpen}
                                onClose={_ => setModalOpen(false)}
                            />
                        </>
                    )}
                </div>
            </div>
        </form>
    )
}

export default BusinessSettingsBilling
